import $ from 'jquery';
import 'what-input';
// import 'is-in-viewport';
// import SuperGif from './lib/libgif.js';
import 'slick-carousel';
import ScrollMagic from 'ScrollMagic';
import 'particles.js';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
// import './lib/jquery.waypoints.min';

$(document).foundation();

$(document).ready(function() {

	////////// preload animation GIFs //////////

	init_animated_preload('./assets/img/Landing-Line.gif', './assets/img/Relay-Landing-Dots.gif', './assets/img/Relay-Map.gif', './assets/img/X.gif', './assets/img/Triangle.gif');

	function init_animated_preload() {
	  for (var i = 0; i < arguments.length; i++) {
	    $("<img />").attr("src", arguments[i]);
	  }
	}

	/// Not leave single word on new line ///////
	header_never_leave_single_word();
	function header_never_leave_single_word() {
		$('h1, h2, h3, .header-mobile-nav a').each(function() {
			var thisHTML = $(this).html();
			var blanks = thisHTML.split(' ');
			if (blanks.length > 2) {
				$(this).html(thisHTML.replace(/\s([^\s<]{0,26})\s*$/,'&nbsp;$1'));
			}
		});
	}


	////////// sticky header //////////

	init_sticky_header_v2();

	function init_sticky_header_v2() {
		var header = $('.header'),
			main = $('.main'),
			section = $('.main section:first-child'),
			headerHeight = header.height(),
			lastScrollTop = 0;

		main.css('padding-top', headerHeight);
		section.css('margin-top', -headerHeight);
		section.css('padding-top', headerHeight);
		$(window).resize(function () {
			var headerHeight = header.height();
			main.css('padding-top', headerHeight);
			section.css('margin-top', -headerHeight);
			section.css('padding-top', headerHeight);
		});

		$(window).on('scroll', function () {
			var st = window.pageYOffset || document.documentElement.scrollTop;
			if (st > headerHeight * 2) {
				header.addClass('sticky')
			}

			if (st === 0) {
				header.removeClass('sticky');
			}

			if (st > lastScrollTop){
				if (st > headerHeight) {
					header.removeClass('slide-down');
					header.addClass('slide-up');
				}
				// downscroll code
			} else {
				if (st === 0) {
					header.removeClass('slide-down');
					header.removeClass('slide-up');
				}  else {
					header.addClass('slide-down');
					header.removeClass('slide-up');
				}
				// upcroll code
			}
			lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
		});

		$(document).on("mousemove", function (e) {
			var headerPos = header.height() + 50;

			if (e.clientY - headerPos < 0 && (parseInt(header.css('top')) < 0)) {
				header.addClass("slide-down");
				header.removeClass("slide-up");
			}
		});
	}

	// init_sticky_header();

	function init_sticky_header() {
		var prevScrollpos = window.pageYOffset,
			lastScrollTop = 0;

		window.onscroll = function () {
			bm_sticky();
		};

		var header = $("#sticky-header"),
			pseudoHeader = $("#pseudo-header"); // var $header = $('#sticky-header');

		var sticky = header.offset().top + 400,
			headerHeight = header.height() + 1;

		function bm_sticky() {
			var currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;

			if (document.documentElement.scrollTop >= headerHeight || prevScrollpos - currentScrollPos - headerHeight > headerHeight && document.documentElement.scrollTop >= headerHeight) {

				if (prevScrollpos - currentScrollPos > 0) {
					header.addClass("sticky");
					pseudoHeader.addClass("sticky");

					header.addClass("slide-down");
					header.removeClass("slide-up");
					header.css('top', 0);
				} else {
					// header.addClass("slide-up");
					// header.removeClass("slide-down");
					header.addClass("sticky");
					header.css('top', - headerHeight);
				}
			} else {
				if (lastScrollTop > currentScrollPos) {
					if (document.documentElement.scrollTop == 1) {
						header.addClass("slide-up");
					}

					if (document.documentElement.scrollTop == 0) {
						header.removeClass("sticky");
						pseudoHeader.removeClass("sticky");
					}
				}
			}

			prevScrollpos = currentScrollPos;
			lastScrollTop = currentScrollPos <= 0 ? 0 : currentScrollPos;
		}

		$(document).on("mousemove", function (e) {
			var headerPos = header.height() + 50;

			if (e.clientY - headerPos < 0 && (parseInt(header.css('top')) < 0)) {
				header.addClass("slide-down");
				header.removeClass("slide-up");
				header.css('top', 0);
			}
		});
	}


	////////// scroll button on Homepage //////////

	$('.js-scroll-down').click(function(e){
		e.preventDefault();

		$('html, body').animate({
        scrollTop: $(".home-section-2").offset().top
    }, 500);
	});


	////////// history slider on About page //////////

	$('.history-slider').slick({
		dots: true,
		autoplay: true,
  		autoplaySpeed: 5000,
		adaptiveHeight: true,
		fade: true,
		cssEase: 'linear'
	});


	////////// toggle active state of project gallery menu //////////

	init_project_gallery_menu_state();

	function init_project_gallery_menu_state() {
		var controller = new ScrollMagic.Controller();
		var triggerElement = '.home-projects';

		if ( ! $(triggerElement).length) return 0;

		var scene = new ScrollMagic.Scene({
			triggerElement: triggerElement,
			triggerHook: 0.1
		})
		.addTo(controller);

		scene.on('enter', function (e) {
			var state = e.type == "enter" ? "inside" : "outside";
			$('.js-project-menu-item').addClass('active');
		});

		scene.on('leave', function (e) {
			var state = e.type == "enter" ? "inside" : "outside";
			$('.js-project-menu-item').removeClass('active');
		});
	}


	////////// lines animation on Homepage //////////
	init_lines_animation_v2();

	function init_lines_animation_v2() {
		var sections = $('.section-animation'),
			allGifImages = $('.section-animation .gif-animation > img');

		sections.each(function () {
			var section = $(this),
				heightSection = section.height(),
				startAnimation = section.offset().top + heightSection/3,
				endAnimation = section.offset().top + heightSection,
				gifImages = section.find('.gif-animation > img'),
				lastScrollTop = 0;

			if (section.hasClass('section-animation-loaded')) {
				gifImages.each(function () {
					var src = $(this).attr('src');
					if (src) $(this).attr('src', src.replace('_static', ''));
				});

				section.addClass('loaded');
			}

			$(window).on('scroll', function () {
				var st = window.pageYOffset || document.documentElement.scrollTop,
					windowStartHeightAnimation = st + (window.innerHeight / 3),
					windowEndHeightAnimation = st + window.innerHeight * 2 / 3,
					outSectionDown = windowStartHeightAnimation >= endAnimation,
					outSectionUp = windowEndHeightAnimation <= section.offset().top,
					inSectionDown = windowEndHeightAnimation >= startAnimation && windowEndHeightAnimation <= endAnimation;

				if (st > lastScrollTop){
					if (inSectionDown && !section.hasClass('loaded')) {
						gifImages.each(function () {
							var src = $(this).attr('src');
							if (src) $(this).attr('src', src.replace('_static', ''));
						});

						section.addClass('loaded');
					}

					if (outSectionDown && section.hasClass('loaded')) {
						gifImages.each(function () {
							var src = $(this).attr('src'),
								image = $(this);
							image.fadeOut(1000);
							setTimeout(function (){
								if (!section.hasClass('loaded')) {
									image.attr('src', src.replace('.gif', '_static.gif'));
								}

								image.fadeIn(200);
							}, 1000);
						});
						section.removeClass('loaded');
					}
					// downscroll code
				} else {
					if (inSectionDown && !section.hasClass('loaded')) {
						gifImages.each(function () {
							var src = $(this).attr('src');
							if (src) $(this).attr('src', src.replace('_static', ''));
						});

						section.addClass('loaded');
					}

					if (outSectionUp && section.hasClass('loaded')) {
						gifImages.each(function () {
							var src = $(this).attr('src'),
								image = $(this);
							image.fadeOut(1000);
							setTimeout(function (){
								if (!section.hasClass('loaded')) {
									image.attr('src', src.replace('.gif', '_static.gif'));
								}

								image.fadeIn(200);
							}, 1000);
						});
						section.removeClass('loaded');
					}
					// upscroll code
				}
				lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
			});
		});
	}

	// init_lines_animation();

	function init_lines_animation() {
		var controller = new ScrollMagic.Controller();
		var triggerElement = '.home-hero';
		var gifElement = '.js-line-gif > img';
		var initialTriggerHook = 0.25;
		var nextTriggerHook = 0.9;
		var enter = false;
		var leave = false;
		var start = false;
		var end = false;

		if ( ! $(triggerElement).length) return 0;

		var scene = new ScrollMagic.Scene({
			triggerElement: triggerElement,
			duration: $(window).height(),
			triggerHook: initialTriggerHook,
			reverse: true
		})
		.addTo(controller);

		var triggerHook = scene.triggerHook();

		scene.on('enter', function (e) {
			enter = true;
			leave = false;
		});

		scene.on('leave', function (e) {
			enter = false;
			leave = true;

			var src = $(gifElement).attr('src');
			if (src) $(gifElement).attr('src', src.replace('.gif', '_static.gif'));

			if (end) {
				scene.triggerHook(nextTriggerHook);
			} else {
				scene.triggerHook(initialTriggerHook);
			}
		});

		scene.on('start', function (e) {
			start = true;
			end = false;

			if (enter) {
				var src = $(gifElement).attr('src');
				if (src) $(gifElement).attr('src', src.replace('_static', ''));
			}
		});

		scene.on('end', function (e) {
			start = false;
			end = true;

			if (enter) {
				var src = $(gifElement).attr('src');
				if (src) $(gifElement).attr('src', src.replace('_static', ''));

				scene.triggerHook(initialTriggerHook);
			}
		});
	}


	////////// dots and map animation on Homepage //////////

	// init_dots_and_map_animation('.home-section-2', '.js-dots-gif > img');
	// init_dots_and_map_animation('.home-section-3', '.js-map-gif > img');

	function init_dots_and_map_animation(triggerElement, gifElement) {
		var controller = new ScrollMagic.Controller();
		var initialTriggerHook = 0.25;
		var nextTriggerHook = 0.9;
		var enter = false;
		var leave = false;
		var start = false;
		var end = false;

		if ( ! $(triggerElement).length) return 0;

		var scene = new ScrollMagic.Scene({
			triggerElement: triggerElement,
			duration: $(window).height(),
			triggerHook: initialTriggerHook,
			reverse: true
		})
		.addTo(controller);

		scene.on('enter', function (e) {
			enter = true;
			leave = false;
		});

		scene.on('leave', function (e) {
			enter = false;
			leave = true;

			var src = $(gifElement).attr('src');
			if (src) $(gifElement).attr('src', src.replace('.gif', '_static.gif'));

			if (end) {
				scene.triggerHook(nextTriggerHook);
			} else {
				scene.triggerHook(initialTriggerHook);
			}
		});

		scene.on('start', function (e) {
			start = true;
			end = false;

			if (enter) {
				var src = $(gifElement).attr('src');
				if (src) $(gifElement).attr('src', src.replace('_static', ''));
			}
		});

		scene.on('end', function (e) {
			start = false;
			end = true;

			if (enter) {
				var src = $(gifElement).attr('src');
				if (src) $(gifElement).attr('src', src.replace('_static', ''));
			}
		});
	}


	////////// x and trianlge animation on About page //////////

	init_x_triangle_animation('.about-intro', '.js-x-gif > img');
	init_x_triangle_animation('.js-triangle-gif-trigger', '.js-triangle-gif > img');

	function init_x_triangle_animation(triggerElement, gifElement) {
		var controller = new ScrollMagic.Controller();
		var initialTriggerHook = 0.4;

		if ( ! $(triggerElement).length) return 0;

		var scene = new ScrollMagic.Scene({
			triggerElement: triggerElement,
			duration: $(window).height(),
			triggerHook: initialTriggerHook,
			reverse: false
		})
		.addTo(controller);

		var triggerHook = scene.triggerHook();

		scene.on('enter', function (e) {
			var src = $(gifElement).attr('src');
			if (src) $(gifElement).attr('src', src.replace('_static', ''));
		});
	}


	////////// tinting on Project page //////////

	init_tinting_change();

	function init_tinting_change() {
		var controller = new ScrollMagic__WEBPACK_IMPORTED_MODULE_3___default.a.Controller();
		var triggerElement = '.js-project-paragraph';
		var initialTriggerHook = 0.5;
		var opacity = 0.3;

		if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(triggerElement).length){
			return 0;
		}
		var scene = new ScrollMagic__WEBPACK_IMPORTED_MODULE_3___default.a.Scene({
			triggerElement: triggerElement,
			duration: jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).height(),
			triggerHook: initialTriggerHook,
			reverse: true
		}).addTo(controller);
		var triggerHook = scene.triggerHook(),
			prevScrollpos = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop(),
			cellHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.project-intro .cell').outerHeight(true),
			cellTop = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.project-intro .cell').offset().top,
			summaryTop = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.project-intro .project-summary').offset().top,
			summaryHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.project-intro .project-summary').outerHeight(true),
			scrollRange = cellHeight - summaryHeight,
			maxOpacity = 0.5,
			minOpacity = 0.3;
		jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scroll(function () {
			var currentScrollPos = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop();

			if (currentScrollPos >= cellTop && currentScrollPos <= cellHeight) {
				if (currentScrollPos >= cellTop && currentScrollPos <= summaryTop) {
					if (prevScrollpos - currentScrollPos > 0) {
						opacity = maxOpacity - ((maxOpacity - minOpacity) * ((summaryTop - currentScrollPos) / scrollRange));
					} else {
						opacity = minOpacity + ((maxOpacity - minOpacity) * ((currentScrollPos - cellTop) / scrollRange));
					}
				}

				if(opacity > maxOpacity) {
					opacity = maxOpacity;
				}
				if(opacity < minOpacity) {
					opacity = minOpacity;
				}
				jquery__WEBPACK_IMPORTED_MODULE_0___default()('.project-intro .overlay').css('background-color', `rgba(0,0,0, ${opacity})`);
			}
		});
		scene.on('enter', function (e) {
			jquery__WEBPACK_IMPORTED_MODULE_0___default()('.project-intro').addClass('project-intro--darker');
		});
		scene.on('leave', function (e) {
			jquery__WEBPACK_IMPORTED_MODULE_0___default()('.project-intro').removeClass('project-intro--darker');
		});
	}

});

// final section particles.js
particlesJS("particles-js", {
	"particles":{
			"number":{
					"value":50,
					"density": {
							"enable": true,
							"value_area": 1000
					}
			},
			"color": {
					"value": '#66dcd1',
			},
			"shape": {
					"type":"circle",
			},
			"opacity":{
					"value":0.71,
					"random":true,
			},
			"size":{
					"value":24,
					// "random":true,
			},
			"line_linked":{
					"enable":false,
			},
			"move":{
					"enable":true,
					"speed":0.5,
					"direction":"none",
					"random":false,
					"straight":false,
					"out_mode":"out",
					"bounce":false,
					"attract":{
							"enable":false,
					}
			}
	},
	"interactivity":{
			"detect_on":"canvas",
			"events":{
					"onhover":{
							"enable":false,
					},
					"onclick":{
							"enable":false,
					},
					"resize":true
			},
	},
	"retina_detect":true
});
